import SearchWidget from './SearchWidget.svelte';

// const target = document.getElementById('quick-finder');

// const app = new QuickFinder({
// 	target: target,
// });

// export default app;

window.SearchWidget = function (options) {
    return new SearchWidget(options);
};